<template>
  <div class="thoughtParty">
    <div class="body">
      <!-- <SzztkHeader /> -->
      <div class="top_nav w1000" style="display:none">
        <a href="http://www.people.cn/" target="_blank"><img src="../../assets/image/new-szztk/cfsl/logo_rmw.png"></a><span></span>
      </div>

      <div class="banner">

      </div>
      <div class="w1000 p1_con">
        <ul class="list list0">
          <li v-for="item,index in listData" :key="index"><span>
              <a href="javascript:void(0);">
                <img :src="item.img_path" width="364" height="241"></a> </span>
            <div>
              <strong>{{item.title}}</strong>
              <p>{{item.sub_text}}
              </p>
              <div class="resource">
                <a href="javascript:void(0);" @click="toSzyskDetail(sub)" v-for="sub,sinx in item.resource_group" :key="sinx">·{{sub.type=="1"?"【图文】":"【视频】"}}{{sub.text}}</a>
              </div>
            </div>
          </li>
        </ul>

      </div>

    </div>
  </div>
</template>

<script>
// import SzztkHeader from "../../components/szztkHeader.vue"

import { mapActions } from "vuex"

export default {
  name: "xfrw",
  components: {
    // SzztkHeader,
  },
  data () {
    return {
      listData: [
        {
          title: "开创新时代社会主义现代化强省建设新局面——沿着总书记的足迹·山东篇",
          sub_text: "   情深似海，厚望如山。党的十八大以来，习近平总书记3次赴山东考察调研，参加十三届全国人大一次会议山东代表团审议，多次发表重要讲话、作出重要指示批示，为山东发展把舵领航、指引方向，赋予山东“在服务和融入新发展格局上走在前、在增强经济社会发展创新力上走在前、在推动黄河流域生态保护和高质量发展上走在前”“开创新时代社会主义现代化强省建设新局面”的光荣使命。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/shandong.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "开创新时代社会主义现代化强省建设新局面——沿着总书记的足迹·山东篇", res_path: "http://cpc.people.com.cn/n1/2022/0609/c64387-32441846.html" },

          ]
        },
        {
          title: "奋力开创社会稳定和长治久安新局面——沿着总书记的足迹·新疆篇",
          sub_text: "党的十八大以来，以习近平同志为核心的党中央高度重视新疆工作，从战略和全局高度审视、谋划、部署新疆工作，深化对治疆规律的认识和把握，形成了新时代党的治疆方略。2020年9月，习近平总书记在第三次中央新疆工作座谈会上强调，要完整准确贯彻新时代党的治疆方略，牢牢扭住新疆工作总目标，依法治疆、团结稳疆、文化润疆、富民兴疆、长期建疆，以推进治理体系和治理能力现代化为保障，多谋长远之策，多行固本之举，努力建设团结和谐、繁荣富裕、文明进步、安居乐业、生态良好的新时代中国特色社会主义新疆。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/xinjiang.jpg"),
          path: "http://cpc.people.com.cn/n1/2022/0629/c64387-32459794.html",
          resource_group: [
            { type: "1", text: "【沿着总书记的足迹】奋力开创社会稳定和长治久安新局面-新疆篇", res_path: "http://cpc.people.com.cn/n1/2022/0629/c64387-32459794.html" },
            { type: "2", text: "【沿着总书记的足迹】建设新时代大美新疆", res_path: "http://v.people.cn/n1/2022/0629/c141029-32460872.html" }
          ]
        },
        {
          title: "推进青藏高原生态保护和高质量发展取得新成就——沿着总书记的足迹·青海篇",
          sub_text: "高原长天流云，三江奔涌不息。党的十八大以来，习近平总书记两次赴青海考察调研、两次参加全国人大会议青海代表团审议，作出一系列重要指示批示，寄予“在推进青藏高原生态保护和高质量发展上不断取得新成就”的殷切期望，为青海发展指明了前进方向、提供了根本遵循。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/qinghai.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/436924/index.html",
          resource_group: [
            { type: "1", text: "推进青藏高原生态保护和高质量发展取得新成就——沿着总书记的足迹·青海篇", res_path: "http://cpc.people.com.cn/n1/2022/0628/c64387-32458429.html" },
            { type: "2", text: "【【沿着总书记的足迹】筑牢生态屏障 奋力谱写新时代青海篇章", res_path: "http://v.people.cn/n1/2022/0628/c141029-32459447.html" }
          ]
        },
        {
          title: "奋力开创首都发展更加美好的明天——沿着总书记的足迹·北京篇",
          sub_text: "“建设和管理好首都，是国家治理体系和治理能力现代化的重要内容。”党的十八大以来，习近平总书记先后10次考察北京，18次对北京工作发表重要讲话，深刻回答了“建设一个什么样的首都，怎样建设首都”这一重大时代课题，为做好新时代首都工作提供了根本遵循。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/beijing.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441135/index.html",
          resource_group: [
            { type: "1", text: "奋力开创首都发展更加美好的明天——沿着总书记的足迹·北京篇", res_path: "http://cpc.people.com.cn/n1/2022/0627/c64387-32457137.html" },
            { type: "2", text: "【沿着总书记的足迹】谱写新时代首都发展崭新篇章", res_path: "http://v.people.cn/n1/2022/0627/c141029-32458103.html" }
          ]
        },
        {
          title: "努力建设黄河流域生态保护和高质量发展先行区——沿着总书记的足迹·宁夏篇",
          sub_text: "塞上江南，天高云淡，黄河滋养的这片沃土，生机盎然。党的十八大以来，习近平总书记两次赴宁夏考察并发表重要讲话，多次对宁夏工作作出重要指示，为建设美丽新宁夏指明了前进方向、提供了根本遵循。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/ningxia.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441136/index.html",
          resource_group: [
            { type: "1", text: "努力建设黄河流域生态保护和高质量发展先行区——沿着总书记的足迹·宁夏篇", res_path: "http://cpc.people.com.cn/n1/2022/0626/c64387-32456743.html" },
            { type: "2", text: "【沿着总书记的足迹】宁夏：“塞上江南”万象新", res_path: "http://v.people.cn/n1/2022/0626/c61600-32456882.html" }
          ]
        },
        {
          title: "加快建设具有世界影响力的社会主义现代化国际大都市——沿着总书记的足迹·上海篇",
          sub_text: "襟江带海，长风万里；百舸争流，奋楫者先。党的十八大以来，习近平总书记多次到上海考察调研、出席重要活动，5次参加十二届全国人大上海代表团审议，作出重要指示，交办重大任务，赋予重大使命。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/shanghai.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441137/index.html",
          resource_group: [
            { type: "1", text: "加快建设具有世界影响力的社会主义现代化国际大都市——沿着总书记的足迹·上海篇", res_path: "http://cpc.people.com.cn/n1/2022/0625/c64387-32456245.html" },
            { type: "2", text: "【沿着总书记的足迹】上海：勇担新使命 当好排头兵", res_path: "http://v.people.cn/n1/2022/0625/c61600-32456516.html" }
          ]
        },
        {
          title: "不断开创富民兴陇新局面——沿着总书记的足迹·甘肃篇",
          sub_text: "黄河水奔腾不息，祁连山绿意盎然，河西走廊丰收在望，陇原大地活力澎湃。党的十八大以来，习近平总书记两次赴甘肃考察调研，参加十三届全国人大二次会议甘肃代表团审议，多次作出重要指示，为甘肃发展把脉定向、指路领航。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/gansu.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441138/index.html",
          resource_group: [
            { type: "1", text: "不断开创富民兴陇新局面——沿着总书记的足迹·甘肃篇", res_path: "http://cpc.people.com.cn/n1/2022/0624/c64387-32455234.html" },
            { type: "2", text: "【沿着总书记的足迹】谱写富民兴陇发展新篇章", res_path: "http://v.people.cn/n1/2022/0624/c61600-32455980.html" }
          ]
        },
        {
          title: "奋力谱写三秦大地高质量发展新篇章——沿着总书记的足迹·陕西篇",
          sub_text: " 黄土高原绿意盎然，关中平原麦浪翻涌，秀美陕南汉水扬波，夏日的三秦大地，一派勃勃生机。党的十八大以来，习近平总书记多次赴陕西考察调研，发表重要讲话、作出重要指示，为陕西发展指明了前进方向、提供了根本遵循。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/q-shanxi.jpg"),


          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "奋力谱写三秦大地高质量发展新篇章——沿着总书记的足迹·陕西篇", res_path: "http://cpc.people.com.cn/n1/2022/0623/c64387-32454081.html" },
            { type: "2", text: "【沿着总书记的足迹】奋楫笃行践初心 三秦大地谱新篇", res_path: "http://v.people.cn/n1/2022/0623/c61600-32454859.html" }
          ]
        },
        {
          title: "谱写雪域高原长治久安和高质量发展新篇章——沿着总书记的足迹·西藏篇",
          sub_text: " 党的十八大以来，习近平总书记高度重视西藏工作，心系西藏各族人民，亲自为新时代西藏工作谋篇布局，多次发表重要讲话、作出重要指示，亲自谋划、亲自部署召开中央第六次、第七次西藏工作座谈会，确立新时代党的治藏方略，为做好新时代西藏工作指明了前进方向、提供了根本遵循。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/xizang.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "谱写雪域高原长治久安和高质量发展新篇章——沿着总书记的足迹·西藏篇", res_path: "http://cpc.people.com.cn/n1/2022/0622/c64387-32452843.html" },
            { type: "2", text: "【沿着总书记的足迹】奋力谱写雪域高原发展新篇章 三秦大地谱新篇", res_path: "http://v.people.cn/n1/2022/0622/c61600-32453743.html" }
          ]
        }, {
          title: "闯出一条跨越式发展的路子——沿着总书记的足迹·云南篇",
          sub_text: "  彩云之南，风和日丽，千山凝碧，万物勃发。党的十八大以来，习近平总书记两次赴云南考察调研，多次给云南干部群众回信，作出一系列重要指示批示，要求云南各族干部群众努力在建设我国民族团结进步示范区、生态文明建设排头兵、面向南亚东南亚辐射中心上不断取得新进展，为云南发展擘画蓝图、指引方向。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/yunnan.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "闯出一条跨越式发展的路子——沿着总书记的足迹·云南篇", res_path: "http://cpc.people.com.cn/n1/2022/0621/c64387-32451693.html" },
            { type: "2", text: "【沿着总书记的足迹】彩云之南跨越式发展谱新篇", res_path: "http://v.people.cn/n1/2022/0621/c61600-32452560.html" }
          ]
        }, {
          title: "努力开创百姓富生态美的新未来——沿着总书记的足迹·贵州篇",
          sub_text: "  黔北高原，群山葱郁，赤水河奔腾蜿蜒；苗岭深处，芦笙悠扬，六冲河山歌欢唱；科创园内，数据如涌，场景应用层出不穷……今日贵州，满眼生机，愈加多姿多彩。党的十八大以来，习近平总书记两次赴贵州考察调研，参加十二届全国人大二次会议贵州代表团审议，参加党的十九大贵州省代表团讨论，多次就贵州工作作出重要指示，要求贵州在新时代西部大开发上闯新路，在乡村振兴上开新局，在实施数字经济战略上抢新机，在生态文明建设上出新绩，为贵州发展指明了前进方向、提供了根本遵循。",

          img_path: require("../../assets/image/new-szztk/yzzszzj/guizhou.jpg"),

          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "努力开创百姓富生态美的新未来——沿着总书记的足迹·贵州篇", res_path: "http://cpc.people.com.cn/n1/2022/0620/c64387-32450621.html" },
            { type: "2", text: "【沿着总书记的足迹】开创百姓富生态美的多彩贵州新未来", res_path: "http://v.people.cn/n1/2022/0620/c61600-32451390.html" }
          ]
        }, {
          title: "奋力推动新时代治蜀兴川再上新台阶——沿着总书记的足迹·四川篇",
          sub_text: " 天府之国富足安宁、巴山蜀水秀美安澜、人民生活幸福安逸……新时代治蜀兴川的美丽图景，正清晰呈现于世人眼前。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/sichuan.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "奋力推动新时代治蜀兴川再上新台阶——沿着总书记的足迹·四川篇", res_path: "http://cpc.people.com.cn/n1/2022/0619/c64387-32450090.html" },
            { type: "2", text: "【沿着总书记的足迹】新时代治蜀兴川再上新台阶", res_path: "http://v.people.cn/n1/2022/0619/c141029-32450309.html" }
          ]
        },
        {
          title: "在发挥“三个作用”上展现更大作为——沿着总书记的足迹·重庆篇",
          sub_text: "  大江奔流向东，水清岸绿；山城奋楫笃行，路畅业兴。党的十八大以来，习近平总书记两次赴重庆考察调研，参加十三届全国人大一次会议重庆代表团审议，多次为重庆发展把脉定向。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/chongqing.jpg"),

          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "在发挥“三个作用”上展现更大作为——沿着总书记的足迹·重庆篇", res_path: "http://cpc.people.com.cn/n1/2022/0618/c64387-32449843.html" },
            { type: "2", text: "【沿着总书记的足迹】绘就高质量发展高品质生活巴渝新图景", res_path: "http://v.people.cn/n1/2022/0618/c61600-32450021.html" }
          ]
        },
        {
          title: "加快建设具有世界影响力的中国特色自由贸易港——沿着总书记的足迹·海南篇",
          sub_text: "  风起海之南，浪逐自贸港。党的十八大以来，习近平总书记先后3次考察海南，发表重要讲话，作出重要指示，为海南发展擘画了宏伟蓝图。牢记总书记殷切嘱托，海南干部群众进一步解放思想、开拓创新，团结奋斗、攻坚克难，书写加快建设中国特色自由贸易港的新篇章。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/hainan.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "加快建设具有世界影响力的中国特色自由贸易港——沿着总书记的足迹·海南篇", res_path: "http://cpc.people.com.cn/n1/2022/0617/c64387-32448866.html" },
            { type: "2", text: "【沿着总书记的足迹】改革开放新高地 琼州潮涌展宏图", res_path: "http://v.people.cn/n1/2022/0617/c61600-32449690.html" }
          ]
        }, {
          title: "构建全方位开放发展新格局——沿着总书记的足迹·广西篇",
          sub_text: "  秀美山水甲天下，生态优势金不换；一湾相挽十一国，良性互动东中西……在广西这片热土上，以12个世居民族为代表的各族人民生生不息，用勤劳、勇敢和智慧，浇灌出八桂大地的美丽富饶。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/guangxi.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "构建全方位开放发展新格局——沿着总书记的足迹·广西篇", res_path: "http://cpc.people.com.cn/n1/2022/0616/c64387-32447761.html" },
            { type: "2", text: "【沿着总书记的足迹】建设新时代中国特色社会主义壮美广西", res_path: "http://v.people.cn/n1/2022/0616/c61600-32448627.html" }
          ]
        }, {
          title: "奋力在新征程中创造新的辉煌——沿着总书记的足迹·广东篇",
          sub_text: "  广东是改革开放的排头兵、先行地、实验区，在我国改革开放和社会主义现代化建设大局中具有十分重要的地位和作用。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/guangdong.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "奋力在新征程中创造新的辉煌——沿着总书记的足迹·广东篇", res_path: "http://cpc.people.com.cn/n1/2022/0615/c64387-32446571.html" },
            { type: "2", text: "【沿着总书记的足迹】奏响新时代南粤大地华美乐章", res_path: "http://v.people.cn/n1/2022/0615/c61600-32447548.html" }
          ]
        }, {
          title: "在推动高质量发展上闯出新路子——沿着总书记的足迹·湖南篇",
          sub_text: "  武陵叠翠，洞庭扬波，夏日三湘大地，处处生机盎然。党的十八大以来，习近平总书记三次赴湖南考察调研，从党和国家战略全局高度对湖南发展锚定新坐标、明确新定位、赋予新使命，为湖南发展指明了前进方向、提供了根本遵循。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/hunan.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "在推动高质量发展上闯出新路子——沿着总书记的足迹·湖南篇", res_path: "http://cpc.people.com.cn/n1/2022/0614/c64387-32445498.html" },
            { type: "2", text: "【沿着总书记的足迹】建设富饶美丽幸福新湖南", res_path: "http://v.people.cn/n1/2022/0614/c61600-32446343.html" }
          ]
        }, {
          title: "奋力谱写新时代高质量发展新篇章——沿着总书记的足迹·湖北篇",
          sub_text: "  “着力在推进经济发展方式转变和产业结构调整上取得新突破，着力在推进农业现代化上不断取得新成果，着力在保障和改善民生上不断取得新进展，着力在生态文明建设上取得新成效，使湖北经济更好、结构更优、质量更高、后劲更足、实力更强。”2013年7月，习近平总书记在湖北考察时，对湖北广大干部群众寄予殷切期望",
          img_path: require("../../assets/image/new-szztk/yzzszzj/hubei.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "奋力谱写新时代高质量发展新篇章——沿着总书记的足迹·湖北篇", res_path: "http://cpc.people.com.cn/n1/2022/0613/c64387-32444497.html" },
            { type: "2", text: "【沿着总书记的足迹】江潮奔涌千帆竞 荆楚大地谱新篇", res_path: "http://v.people.cn/n1/2022/0613/c61600-32445331.html" }
          ]
        }, {
          title: "谱写新时代中原更加出彩的绚丽篇章——沿着总书记的足迹·河南篇",
          sub_text: "   广袤中原，麦熟飘香，8500多万亩麦田丰收在望。习近平总书记情系中原大地，党的十八大以来，先后4次赴河南考察调研，多次作出重要讲话、重要指示，寄予河南“在中部地区崛起中奋勇争先，谱写新时代中原更加出彩的绚丽篇章”殷殷嘱托，为现代化河南建设提供了总纲领、总遵循、总指引。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/henan.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "谱写新时代中原更加出彩的绚丽篇章——沿着总书记的足迹·河南篇", res_path: "http://cpc.people.com.cn/n1/2022/0611/c64387-32443782.html" },
          ]
        }, {
          title: "在推动中部地区崛起上勇争先——沿着总书记的足迹·江西篇",
          sub_text: "革命老区高质量发展上作示范、在推动中部地区崛起上勇争先”的殷切嘱托。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/jiangxi.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "在推动中部地区崛起上勇争先——沿着总书记的足迹·江西篇", res_path: "http://cpc.people.com.cn/n1/2022/0608/c64387-32440890.html" },
          ]
        }, {
          title: "闽山闽水物华新——沿着总书记的足迹·福建篇",
          sub_text: "  “这里的山山水水、一草一木，我深有感情。离开福建以后，我也一直关注福建。在这里工作期间的一些思考和探索，在我后来的工作中仍在思考和深化，有些已经在全国更大范围实践了。”习近平同志曾在福建工作了17年半，开创性地提出了一系列重要理念、推进了一系列重大实践。八闽大地的山山水水和父老乡亲，总书记始终牵挂在心。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/fujian.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "闽山闽水物华新——沿着总书记的足迹·福建篇", res_path: "http://cpc.people.com.cn/n1/2022/0607/c64387-32439747.html" },

          ]
        },
        {
          title: "在新发展格局中实现更大作为——沿着总书记的足迹·安徽篇",
          sub_text: "   初夏的风，吹过江淮大地。大山深处，村民陈泽申摘下一篓新茶：真想请总书记尝一尝这让我们过上好日子的致富茶！2016年4月24日下午，习近平总书记走进安徽省金寨县大湾村，就在陈泽申家的院子里，关切地询问村子里的脱贫情况。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/anhui.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "在新发展格局中实现更大作为——沿着总书记的足迹·安徽篇", res_path: "http://cpc.people.com.cn/n1/2022/0606/c64036-32438933.html" },
          ]
        },

        {
          title: "践行“八八战略”  打造“重要窗口”——沿着总书记的足迹·浙江篇",
          sub_text: "   “坚持以‘八八战略’为统领，干在实处、走在前列、勇立潮头”“努力成为新时代全面展示中国特色社会主义制度优越性的重要窗口”——2020年3月29日至4月1日，习近平总书记在浙江考察时提出明确要求。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/zhejiang.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "践行“八八战略”  打造“重要窗口”——沿着总书记的足迹·浙江篇", res_path: "http://cpc.people.com.cn/n1/2022/0603/c64387-32437722.html" },
          ]
        },

        {
          title: "在率先实现社会主义现代化上走在前列——沿着总书记的足迹·江苏篇",
          sub_text: "  党的十八大以来，习近平总书记先后三次赴江苏考察调研，对江苏发展多次作出重要指示，为江苏擘画了“经济强、百姓富、环境美、社会文明程度高”的宏伟蓝图，赋予江苏“在改革创新、推动高质量发展上争当表率，在服务全国构建新发展格局上争做示范，在率先实现社会主义现代化上走在前列”的光荣使命。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/jiangsu.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "在率先实现社会主义现代化上走在前列——沿着总书记的足迹·江苏篇", res_path: "http://cpc.people.com.cn/n1/2022/0602/c64387-32436630.html" },

          ]
        }, {
          title: "奋力走出全面振兴全方位振兴新路子——沿着总书记的足迹·黑龙江篇",
          sub_text: "   林海吐翠，潮涌三江，广袤的龙江大地生机勃发。党的十八大以来，习近平总书记一直关注黑龙江，始终牵挂黑土地，两次赴黑龙江考察调研，参加十二届全国人大四次会议黑龙江代表团审议，多次就东北、黑龙江振兴发展发表重要讲话、作出重要指示，为新时代黑龙江振兴发展指明了前进方向、提供了根本遵循。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/heilongjiang.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "奋力走出全面振兴全方位振兴新路子——沿着总书记的足迹·黑龙江篇", res_path: "http://cpc.people.com.cn/n1/2022/0601/c64387-32435456.html" },

          ]
        },
        {
          title: "加快推动全面振兴全方位振兴——沿着总书记的足迹·吉林篇",
          sub_text: "  从松辽平原到海兰江畔，从查干湖岸到企业园区，党的十八大以来，习近平总书记3次赴吉林考察调研，深入农村、社区、科技园区、企业，为推动新时代吉林全面振兴全方位振兴提供了根本遵循、指明了前进方向、注入了强大动力。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/jilin.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "加快推动全面振兴全方位振兴——沿着总书记的足迹·吉林篇", res_path: "http://cpc.people.com.cn/n1/2022/0531/c64387-32434441.html" },
          ]
        },
        {
          title: "奋力开创全面振兴全方位振兴新局面——沿着总书记的足迹·辽宁篇",
          sub_text: "   汤汤辽河水，悠悠黑土情。习近平总书记始终对辽宁高度重视、深情牵挂、亲切关怀，党的十八大以来，两次赴辽宁考察，两次参加全国人大辽宁代表团审议，多次就东北、辽宁振兴发展发表重要讲话、作出重要指示，为辽宁振兴发展取得新突破明确方向、指明路径。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/liaoning.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "奋力开创全面振兴全方位振兴新局面——沿着总书记的足迹·辽宁篇", res_path: "http://cpc.people.com.cn/n1/2022/0530/c64387-32433403.html" },
            { type: "2", text: "【沿着总书记的足迹】辽宁：全面振兴全方位振兴谱新篇", res_path: "http://v.people.cn/n1/2022/0530/c61600-32434254.html" },
          ]
        }, {
          title: "把祖国北疆这道风景线建设得更加亮丽——沿着总书记的足迹·内蒙古篇",
          sub_text: "   巍巍兴安岭、茫茫敕勒川，初夏的内蒙古大地生机勃勃、绿意盎然。内蒙古是我国最早成立民族自治区、党的民族区域自治制度最早付诸实施的地方，地处祖国北疆，战略地位十分重要。党的十八大以来，以习近平同志为核心的党中央对内蒙古高度重视、亲切关怀，习近平总书记先后两次考察内蒙古、连续5年参加十三届全国人大历次会议内蒙古代表团审议并发表重要讲话、多次就内蒙古工作作出重要指示批示，指引和推动内蒙古各项事业取得历史性成就、发生历史性变革。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/neimenggu.jpg"),
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "把祖国北疆这道风景线建设得更加亮丽——沿着总书记的足迹·内蒙古篇", res_path: "http://cpc.people.com.cn/n1/2022/0527/c64387-32431617.html" },
            { type: "2", text: "【沿着总书记的足迹】内蒙古：打造祖国北部边疆亮丽风景线", res_path: "http://v.people.cn/n1/2022/0527/c61600-32432535.html" }
          ]
        }, {
          title: "在高质量发展上不断取得新突破——沿着总书记的足迹·山西篇",
          sub_text: "  “到中央工作后，我一直关注着山西。”党的十八大以来，习近平总书记三度赴山西考察调研，为山西发展指明了前进方向、提供了根本遵循、注入了强大动力。",
          img_path: require("../../assets/image/new-szztk/yzzszzj/j-shanxi.jpg"),

          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          resource_group: [
            { type: "1", text: "在高质量发展上不断取得新突破——沿着总书记的足迹·山西篇", res_path: "http://cpc.people.com.cn/n1/2022/0526/c64387-32430641.html" },
            { type: "2", text: "【沿着总书记的足迹】三晋大地高质量转型发展天地阔", res_path: "http://v.people.cn/n1/2022/0526/c61600-32431446.html" }
          ]
        },
        {
          title: "在新的“赶考”之路上书写优异答卷——沿着总书记的足迹·河北篇",
          sub_text: "  党的十八大以来，习近平总书记先后9次考察河北。从太行深处到渤海之滨，从冀中平原到塞外山城，总书记关心百姓冷暖安危，指导河北走好发展新路，给河北人民巨大鼓舞。",
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          img_path: require("../../assets/image/new-szztk/yzzszzj/hebei.jpg"),
          resource_group: [
            { type: "1", text: "在新的“赶考”之路上书写优异答卷——沿着总书记的足迹·河北篇", res_path: "http://cpc.people.com.cn/n1/2022/0525/c64387-32429659.html" },
            { type: "2", text: "【沿着总书记的足迹】河北：奋力书写“赶考”路上新答卷", res_path: "http://v.people.cn/n1/2022/0525/c61600-32430464.html" },
          ]
        },

        {
          title: "全面建设社会主义现代化大都市——沿着总书记的足迹·天津篇",
          sub_text: "   风起渤海之滨，潮涌海河两岸。    党的十八大以来，中国特色社会主义进入新时代，天津也进入一个新的发展时期。2013年5月、2019年1月，习近平总书记两度亲临天津考察，殷殷嘱托，为天津发展指明了前进方向、提供了根本遵循、注入了强大动力。",
          path: "http://cpc.people.com.cn/GB/67481/441140/index.html",
          img_path: require("../../assets/image/new-szztk/yzzszzj/tianjin.jpg"),
          resource_group: [
            { type: "1", text: "全面建设社会主义现代化大都市——沿着总书记的足迹·天津篇", res_path: "http://cpc.people.com.cn/n1/2022/0524/c64387-32428529.html" },
            { type: "2", text: "【沿着总书记的足迹】天津：渤海明珠涌新潮", res_path: "http://v.people.cn/n1/2022/0524/c61600-32429428.html" },
          ]
        },

      ]
    };
  },
  methods: {
    ...mapActions(['goAppsDetailsBeforeLogin',]),
    toSzyskDetail (item) {
      // let that = this;
      // that.goAppsDetailsBeforeLogin().then(() => {
      window.open(item.res_path, '_blank')
      // })
    },
  }

};
</script>

<style lang="less"  scoped>
.banner {
  height: 500px;
  background: url('../../assets/image/new-szztk/cfsl/header_banner.jpg')
    no-repeat top center;
  padding-top: 310px;
}
/* CSS Document */
body {
  padding: 0;
  margin: 0;
  color: #000000;
  text-align: center;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}

div {
  margin: 0 auto;
  text-align: left;
}
a:link,
a:visited {
  color: #000;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

img {
  border: none;
  cursor: default;
}

ol,
ul,
li {
  list-style: none;
}

em,
i {
  font-style: normal;
}

.clear {
  clear: both;
}

/* clearfix */
.clearfix:before,
.clearfix:after {
  content: '';
  display: table;
}

.clearfix:after {
  clear: both;
  overflow: hidden;
}

.clearfix {
  zoom: 1;
}

/*other*/
.fl {
  float: left;
}

.fr {
  float: right;
}

.m0 {
  margin: 0 auto;
}

.m10 {
  margin: 10px auto;
}

.mb10 {
  margin-bottom: 10px;
}

.mb15 {
  margin-bottom: 15px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt5 {
  margin-top: 5px;
}

.mt10 {
  margin-top: 10px;
}

.mt20 {
  margin-top: 20px;
}

.mt12 {
  margin-top: 12px;
}

.mt15 {
  margin-top: 15px;
}

.mt17 {
  margin-top: 17px;
}

.ml5 {
  margin-left: 5px;
}

.ml10 {
  margin-left: 10px;
}

.ml15 {
  margin-left: 15px;
}

.ml25 {
  margin-left: 25px;
}

.mr5 {
  margin-right: 5px;
}

.mr10 {
  margin-right: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.p5 {
  padding: 5px 0;
}

.p3 {
  padding: 3px 0;
}

.p0 {
  padding: 0;
}

.p10 {
  padding: 10px;
}

.pb10 {
  padding-bottom: 10px;
}

.pb15 {
  padding-bottom: 15px;
}

.pb1 {
  border-bottom: 1px;
}

.bd1 {
  border: 1px solid #dad0ae;
}

.w1000 {
  width: 1000px;
}

.w980 {
  width: 980px;
}

.w978 {
  width: 978px;
  border: 1px solid #ecddac;
  background: #fff;
}

.w960 {
  width: 960px;
}

.w100 {
  width: 100%;
}

.f14 {
  font-size: 14px;
}

.am2 a {
  margin: 0 2px;
}

.am3 a {
  margin: 0 3px;
}

.am5 a {
  margin: 0 5px;
}

.duan {
  width: 100%;
  height: 8px;
}

.t_c {
  text-align: center;
}

.t_l {
  text-align: left;
}

.t_r {
  text-align: right;
}

.w300 {
  width: 300px;
}

.w360 {
  width: 360px;
}

.list_14 li {
  padding-left: 15px;
  font-size: 14px;
  line-height: 28px;
}

.list_12 li {
  padding-left: 15px;
  line-height: 28px;
}

.list_12 li,
.list_14 li,
.list_14 li a:link,
.list_14 li a:hover,
.list_14 li a:visited,
.list_12 li a:link,
.list_12 li a:hover,
.list_12 li a:visited {
  color: #033266;
}

.l_h26 {
  line-height: 26px;
}

.l_h24 {
  line-height: 24px;
}

.l_h22 {
  line-height: 22px;
}

.o_h {
  overflow: hidden;
}

.white,
.white a:link,
.white a:hover,
.white a:visited {
  color: #fff;
}

.blue,
.blue a:link,
.blue a:hover,
.blue a:visited {
  color: #6997c7;
}

.red,
.red a:link,
.red a:hover,
.red a:visited {
  color: #cc0000;
}

/*top nav*/
.top_nav {
  width: 989px;
  height: 35px;
}

.top_nav img {
  float: left;
  vertical-align: middle;
  margin: 0 20px auto 20px;
}

.top_nav span {
  float: right;
  margin-right: 10px;
  line-height: 35px;
  color: #565656;
}

.top_nav span a {
  color: #565656;
  padding: 0 6px;
}

.top_nav b {
  float: left;
  font-size: 18px;
  color: #be140b;
  font-family: \9ed41\4f53;
  margin-left: 10px;
}

/*p1*/
.p1_con {
  overflow: hidden;
}

.p1_con h2 {
  margin: 25px auto;
}

.p1_con h2 i {
  font-size: 36px;
  color: #cc5145;
  padding-left: 50px;
  height: 44px;
  line-height: 44px;
}

.p1_con ul li {
  padding: 28px 0 60px 0;
  overflow: hidden;
  border-bottom: 1px solid #d1d1d1;
  margin-top: 50px;
}

.p1_con ul li:last-child {
  border: none;
}

.p1_con ul li span {
  float: left;
  width: 364px;
  // height: 300px;
  position: relative;
  margin-right: 30px;
  clear: both;
}

.p1_con ul li span em {
  display: block;
  width: 64px;
  height: 43px;
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  font-size: 18px;
  line-height: 36px;
  text-align: center;
}

// .p1_con ul li div {
//   height: 300px;
// }
.p1_con ul li div div {
  height: unset;
  border-bottom: none;
  display: flex;
  flex-direction: column;
  margin-top: 5px;
}
.p1_con ul li div div a {
  color: #0537b6 !important;
  text-decoration: none;
  font-size: 16px;
  line-height: 28px;
}

.p1_con ul li div strong,
.p1_con ul li div b,
.p1_con ul li div p {
  display: block;
}

.p1_con ul li div strong {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.p1_con ul li div b {
  line-height: 55px;
  color: #787878;
  font-size: 16px;
}

.p1_con ul li div p {
  line-height: 28px;
  font-size: 14px;
}

.p2_con {
  width: 1030px;
  padding: 15px 0;
}

.p2_con img {
  float: left;
  margin: 15px;
}

.p3_con {
  padding: 20px 0;
  overflow: hidden;
  font-size: 14px;
}

.erwm_right {
  position: fixed;
  _position: absolute;
  background-position: 0 -40px;
  display: block;
  width: 88px;
  right: 13px;
  _right: -52px;
  bottom: 90px;
}

.erwm_right ul li {
  width: 86px;
  height: 73px;
  border: 1px solid #ece3db;
  background: #eeebe8;
  text-align: center;
  font-size: 18px;
  line-height: 73px;
  color: #856851;
  margin: 2px auto;
}

.erwm_right ul li:hover {
  background: #c13b3b;
  color: #fff;
}

.erwm_right span {
  width: 86px;
  padding: 10px 0;
  border: 1px solid #ece3db;
  background: #eeebe8;
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  color: #856851;
  display: block;
  overflow: hidden;
  margin: 2px auto;
}

.erwm_right span img {
  display: block;
  margin: 5px auto 15px auto;
}

.go_top {
  position: fixed;
  _position: absolute;
  background-position: 0 -40px;
  display: block;
  width: 88px;
  height: 75px;
  right: 13px;
  _right: -52px;
  bottom: 28px;
  filter: alpha(opacity=80);
  border-top: 2px solid #fff;
}

.go_top:hover {
  filter: alpha(opacity=100);
}

.tc_con {
  width: 1010px;
}

.tc_con3 {
  overflow-y: visible;
  overflow-x: hidden;
  height: 90%;
  width: 1030px;
}

.tc_con ul {
  margin: 60px auto;
}

.tc_con ul li {
  float: left;
  margin: 5px 0 0 5px;
  width: 331px;
  height: 63px;
  background: #e9d3a9;
  color: #704c2f;
}

.tc_con ul li:hover {
  background: #fff1d5;
}

.tc_con ul li a {
  color: #704c2f;
}

.tc_con ul li b {
  font-size: 16px;
  line-height: 63px;
  float: left;
  padding: 0 15px 0 45px;
}

.tc_con ul li p {
  font-size: 14px;
  line-height: 63px;
}

.tc_con ul li p.two em {
  display: block;
  line-height: 20px;
}

.tc_con ul li p.two {
  line-height: 20px;
  padding-top: 10px;
}

.tc_con {
  position: fixed;
  bottom: 10px;
  left: 50%;
  margin-left: -510px;
  z-index: 2;
  display: none;
}

.close {
  position: absolute;
  top: 0;
  right: 0px;
  width: 53px;
  height: 51px;
  cursor: pointer;
}

.tc_bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  display: none;
  text-align: center;
}

.tc_a li {
  position: relative;
  cursor: pointer;
}

.more,
.more1,
.more2,
.more3 {
  text-align: center;
  padding: 20px 0;
  overflow: hidden;
  clear: both;
  font-size: 20px;
  width: 89px;
  height: 40px;
  margin: 0 auto;
}

.list,
.list1,
.list2,
.list3 {
  overflow: hidden;
}

.copyright {
  margin: 0px auto;
  width: 100%;
  font-size: 12px;
  color: #000000;
  text-align: center;
  padding: 20px 0;
  line-height: 180%;
  clear: both;
}

#copyright {
  clear: both;
  margin: 5px auto;
  padding-top: 10px;
  width: 980px;
  height: auto;
  color: #2a3084;
  text-align: center;
}

#copyright p {
  margin: 0 0 2px 0;
  text-align: center;
}

#copyright a {
  color: #2a3084;
}

#copyright p.p1 {
  margin: 15px auto;
  width: 530px;
}

#copyright p.p2 {
  margin: 8px 0 0 0;
}
.bza {
  width: 720px;
  font-size: 14px;
  background: url('../../assets/image/new-szztk/cfsl/bza.png') no-repeat top
    left;
  min-height: 115px;
  color: #305582;
}
.bza p {
  width: 720px;
  padding-left: 70px;
  line-height: 30px;
  text-indent: 2em;
}
.list p {
  text-indent: 2em;
}
</style>
